import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FadeScrollWrapper } from '@app/styles';
import { ComponentSync, LL_H_C, LL_V_L, TS_TextArea, _className } from '@nu-art/thunderstorm-frontend/index';
import './Editor_LogTemplate_Sections.scss';
import { ICONS } from '@app/styles';
import { swapInArrayByIndex } from '@nu-art/ts-common';
export class Editor_LogTemplate_Sections extends ComponentSync {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editable = nextProps.editable;
        state.editMode = nextProps.editMode;
        return state;
    }
    // ######################## Logic ########################
    moveSectionIndex = (sectionIndex, direction) => {
        const lastIndex = this.state.editable.item.length - 1;
        //There is only one child
        if (lastIndex === 0)
            return;
        //First child trying to move up
        if (sectionIndex === 0 && direction === 'up')
            return;
        //Last Child trying to move down
        if (sectionIndex === lastIndex && direction === 'down')
            return;
        const targetIndex = sectionIndex + (direction === 'up' ? -1 : 1);
        const sections = [...this.state.editable.item];
        swapInArrayByIndex(sections, sectionIndex, targetIndex);
        this.state.editable.updateItem(sections);
        this.state.editable.save();
    };
    // ######################## Render ########################
    render() {
        const sections = this.state.editable;
        const lastIndex = this.state.editable.item.length - 1;
        return _jsx(FadeScrollWrapper, { className: 'editor__log-template-sections', children: sections.item.map((section, index) => {
                const moveUpClassName = _className('move-up', index === 0 && 'disabled');
                const moveDownClassName = _className('move-down', index === lastIndex && 'disabled');
                return _jsxs(LL_H_C, { className: 'editor__log-template-sections__section', children: [this.state.editMode && _jsxs(LL_V_L, { className: 'editor__log-template-sections__section__controls', children: [_jsx(ICONS.doubleArrow.component, { className: moveUpClassName, onClick: () => this.moveSectionIndex(index, 'up') }), _jsx(ICONS.bin.component, { className: 'delete', onClick: () => sections.removeArrayItem(index) }), _jsx(ICONS.doubleArrow.component, { className: moveDownClassName, onClick: () => this.moveSectionIndex(index, 'down') })] }), _jsx(TS_TextArea, { type: 'text', disabled: !this.state.editMode, resizeWithText: true, value: section, onBlur: value => sections.updateArrayAt(value, index) })] }, index);
            }) });
    }
}
//# sourceMappingURL=Editor_LogTemplate_Sections.js.map